import DownloadList from './DownloadList';
import DownloadEdit from './DownloadEdit';
import DownloadCreate from "./DownloadCreate";

export default {
    list: DownloadList,
    edit: DownloadEdit,
    create: DownloadCreate,
};
